import React, { useReducer } from "react";
import SegmentsContext from "./SegmentsContext";
import SegmentsReducer from "./SegmentsReducer";
import MethodGet, {
  MethodPost,
  MethodPut,
  MethodDelete,
} from "../../config/service";
import Swal from "sweetalert2";
import {
  GET_ALL_SEGMENTS,
  ADD_SEGMENTS,
  UPDATE_SEGMENTS,
  DELETE_SEGMENTS,
} from "../../types";

const SegmentsState = ({ children }) => {
  const initialState = {
    segments: [],
    segment: null,
    ErrorsApi: [],
    success: false,
  };

  const [state, dispatch] = useReducer(SegmentsReducer, initialState);

  const handleError = (error) => {
    const data = error.response?.data;

    if (data?.errors) {
      const mensajes = Object.values(data.errors).flat().join("\n");
      Swal.fire({
        title: "Error de validación",
        icon: "warning",
        text: mensajes,
      });
    } else if (data?.mensaje) {
      Swal.fire({
        title: data.error || "Error",
        icon: "error",
        text: data.mensaje,
      });
    } else {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "Ocurrió un error inesperado",
      });
    }
  };

  const GetSegments = async () => {
    try {
      let url = "/segments";
      const res = await MethodGet(url);
      dispatch({ type: GET_ALL_SEGMENTS, payload: res.data });
    } catch (error) {
      handleError(error);
    }
  };

  const AddSegmentos = (data) => {
    MethodPost("/segments", data)
      .then((res) => {
        dispatch({ type: ADD_SEGMENTS, payload: res.data });
        Swal.fire({
          title: "Éxito",
          text: "Segmento agregado con éxito",
          icon: "success",
        });
        GetSegments();
      })
      .catch(handleError);
  };

  const UpdateSegments = (data) => {
    MethodPut(`/segments/${data.id}`, data)
      .then((res) => {
        dispatch({ type: UPDATE_SEGMENTS, payload: res.data });
        Swal.fire({
          title: "Éxito",
          text: "Segmento actualizado con éxito",
          icon: "success",
        });
        GetSegments();
      })
      .catch(handleError);
  };

  // const DeleteSegments = (id) => {
  //   Swal.fire({
  //     title: "¿Estás seguro?",
  //     text: "El segmento seleccionado será eliminado",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Sí, eliminar",
  //     cancelButtonText: "No, volver",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MethodDelete(`/segments/${id}`)
  //         .then((res) => {
  //           dispatch({ type: DELETE_SEGMENTS, payload: id });
  //           Swal.fire({
  //             title: "Eliminado",
  //             text: res.data.mensaje,
  //             icon: "success",
  //           });
  //           GetSegments();
  //         })
  //         .catch(handleError);
  //     }
  //   });
  // };

  return (
    <SegmentsContext.Provider
      value={{
        segments: state.segments,
        segment: state.segment,
        ErrorsApi: state.ErrorsApi,
        success: state.success,
        GetSegments,
        AddSegmentos,
        UpdateSegments,
        //DeleteSegments,
      }}
    >
      {children}
    </SegmentsContext.Provider>
  );
};

export default SegmentsState;
